import PropTypes from "prop-types";
import * as React from "react";
import { sizeOf } from "../../utils/propTypes";
import css from "./Chip.module.css";

const Chip = React.forwardRef(
  (
    {
      variant = "assist",
      size = "md",
      selected = false,
      disabled = false,
      label,
      leading,
      avatar,
      onDelete,
      className,
      onClick,
      ...rest
    },
    ref,
  ) => {
    const isInteractive = Boolean(onClick) || variant === "filter";

    const classes = [
      css.root,
      size !== "md" && css[size],
      css[variant],
      selected && css.selected,
      className,
    ]
      .filter(Boolean)
      .join(" ");

    const Component = isInteractive ? "button" : "span";

    const interactiveProps = isInteractive
      ? {
          type: "button",
          disabled,
          onClick,
          "aria-pressed": variant === "filter" ? selected : undefined,
        }
      : {};

    return (
      <Component ref={ref} className={classes} {...interactiveProps} {...rest}>
        {avatar && (
          <img src={avatar} alt="" className={css.avatar} loading="lazy" />
        )}
        {leading && !avatar && <span className={css.leading}>{leading}</span>}
        {label}
        {onDelete && (
          <button
            type="button"
            className={css.deleteBtn}
            onClick={(e) => {
              e.stopPropagation();
              onDelete(e);
            }}
            aria-label={`Remove ${label}`}
            disabled={disabled}
          >
            &#x2715;
          </button>
        )}
      </Component>
    );
  },
);

Chip.displayName = "Chip";

Chip.propTypes = {
  variant: PropTypes.oneOf(["assist", "filter", "input", "suggestion"]),
  size: sizeOf("sm", "md"),
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  leading: PropTypes.node,
  avatar: PropTypes.string,
  onDelete: PropTypes.func,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default Chip;
